import { Fragment, Component } from 'react'
import { connect } from 'react-redux'
import store from 'store2'
import moment from 'moment'
import setQuery from 'set-query-string'
import find from 'lodash/find'
import filter from 'lodash/filter'
import each from 'lodash/each'
import isArray from 'lodash/isArray'
import map from 'lodash/map'
import { FormattedMessage } from 'react-intl'
import ReactTooltip from 'react-tooltip'
import { StickyHeader } from '../components'
import { parseQuery, generateMonthPicker } from '../utils'
import Loader from '../components/helpers/Loader'
import MobileFilterToggle from '../components/search/MobileFilterToggle'
import FiltersGroup from '../components/search-group/FiltersGroup'
import TripItem from '../components/search-group/TripItem'

const SORT_BY = [
  {
    title: <FormattedMessage id='feature' defaultMessage='Featured' />,
    value: '-shop_rating',
  }, {
    title: <FormattedMessage id='cheapest' defaultMessage='Cheapest' />,
    value: 'minimum_price',
  }, {
    title: <FormattedMessage id='guest_rating' defaultMessage='Guest ratings' />,
    value: '-rating',
  }]

const monthes = generateMonthPicker()

const filtersKeys = [
  'departure_date',
  'departure_date_custom',
  'trip_type',
  'trip_language',
  'price',
  'organiser_pk',
  'place_id',
  'organiserTitle',
  'tag',
]

const filtersToClean = [
  'trip_type',
  'trip_language',
  'price',
  'organiser_pk',
  'place_id',
  'organiserTitle',
  'near_by',
  'tag',
]


const filterValueIsString = [
  'organiser_pk',
  'place_id',
  'organiserTitle',
  'near_by',
]

class SearchPageGroup extends Component {
  constructor(props) {
    super(props)

    // let departureDate = store('departure_date')

    // if(departureDate && departureDate.id !== 'available' && departureDate.id !== 'all') {
    //   setQuery({ departure_date: store('departure_date').id })
    // } else if(store('date') || store('departure_date_custom')) {
    //   let dateObj = store('departure_date_custom') || store('date')[0]
    //   let date = moment(dateObj).startOf('month').format('YYYY-MM-DD')
    //   let month = filter(monthes, { from: date })
    //   if(month.length) {
    //     setQuery({ 'departure_date': month[0].id })
    //   }
    //   if(store('departure_date_custom')) {
    //     setQuery({ departure_date_custom: store('departure_date_custom') })
    //   }
    // }

    let selectedParams = parseQuery()
    let filtersCount = 0
    let filterObject = {}

    if(selectedParams) {
      each(selectedParams, function(val, key) {
        if(filtersKeys.indexOf(key) >= 0) {
          if(key === 'departure_date') {
            let departure = find(monthes, {
              id: val,
            })
            // For monthpicker
            filterObject['departure_date_month'] = departure
            if(departure) {
              filterObject[key] = departure.from
              selectedParams[key] = departure.from
            }
          } else if(filterValueIsString.indexOf(key) !== -1) {
            filterObject[key] = decodeURIComponent(val)
          } else if(isArray(val)) {
            filterObject[key] = {}
            filtersCount++
            each(val, function(v) {
              filterObject[key][v] = true
            })
          } else {
            filterObject[key] = {}
            filterObject[key][val] = true
            filtersCount++
          }
        }
      })
    }

    this.state = {
      selectedParams: {
        ordering: SORT_BY[0].value,
        view: 'boats',
        ...selectedParams,
      },
      getNewData: false,
      selectedFilters: filterObject,
      numberOfBoats: this.props.totalCount || 0,
      numberOfTrips: 0,
      numberOfBoatsParent: 0,
      filtersCount,
    }
  }

  updateParams = (params, clearPage) => {
    const firstSeen = false
    let filtersCount = 0
    let tripOrganiserCounter = 0

    if(clearPage) {
      this.setState({
        page: 1,
      })
      setQuery({ page: 1 })
    }

    this.setState({
      selectedFilters: {
        ordering: SORT_BY[0].value,
        view: 'boats',
        ...this.state.selectedFilters,
        ...params,
      },
    }, () => {
      let obj = {}

      each(this.state.selectedFilters, function(val, key) {
        if(filtersKeys.indexOf(key) >= 0) {
          if(key === 'view' || key === 'departure_date_custom' || key === 'ordering') {
            if(key === 'view' && firstSeen) {
              return true
            }

            obj[key] = val
          } else if(key === 'departure_date') {
            let departure = find(monthes, {
              from: val,
            })

            if(departure) { obj[key] = departure.id }
          } else if(filterValueIsString.indexOf(key) !== -1) {
            if(!(params.isNearBy && key === 'organiserTitle')) {
              obj[key] = val
            }
            // kostyl'
            if(val) {
              tripOrganiserCounter = 1
            }
          } else {
            obj[key] = filter(map(val, function(v, k) {
              if(v) {
                return k
              }

              return null
            }), function(v) {
              return v || typeof v === 'number'
            })
          }

          if(isArray(obj[key]) && obj[key].length) {
            filtersCount++
          }
        }
      })

      if(tripOrganiserCounter) {
        filtersCount++
      }

      setQuery(obj)

      if(obj.departure_date) {
        let departure = find(monthes, {
          id: obj.departure_date,
        })

        obj.departure_date = departure.from
        obj.selected_month = departure.id !== '30-days'

        store('departure_date', departure)
        store('date', [departure.from, departure.to])
      } else if(obj.departure_date_custom) {
        store('departure_date_custom', obj.departure_date_custom)
        store('date', [obj.departure_date_custom, moment(obj.departure_date_custom).add(30, 'd').format('YYYY-MM-DD')])
        store.remove('departure_date')
      } else {
        // store.remove('departure_date')
        // store.remove('departure_date_custom')
        // store.remove('date')
      }

      if(params.near_by) {
        obj.near_by = params.near_by
      }

      this.setState({
        selectedParams: obj,
        filtersCount,
      })
    })
  }

  clearSelectedFilters = () => {
    let cleanObj = {}
    each(filtersToClean, function(filter) {
      cleanObj[filter] = undefined
      if(filter === 'organiserTitle') {
        cleanObj[filter] = ''
      }
    })

    setQuery(cleanObj)

    this.setState({
      selectedFilters: {
        ...this.state.selectedFilters,
        ...cleanObj,
      },
      selectedParams: {
        ...this.state.selectedFilters,
        ...cleanObj,
      },
      filtersCount: 0,
    })
  }

  clearDates = () => {
    this.setState({
      selectedFilters: {
        ...this.state.selectedFilters,
        departure_date: null,
        departure_date_month: null,
      },
      selectedParams: {
        ...this.state.selectedFilters,
        departure_date: undefined,
        departure_date_month: undefined,
      },
    })

    setQuery({ departure_date: null })
    store.remove('departure_date')
    store.remove('departure_date_custom')
    store.remove('date')
  }

  triggerApi = () => {
    this.setState({
      getNewData: !this.state.getNewData,
    })
  }

  setNumberOfItems = (number, type) => {
    let obj = { [type]: number }

    this.setState(obj)
  }

  render() {
    return (
      <div className='search-page-la search-group-trip'>
        <StickyHeader locationTitle={this.props.title} />
        <ReactTooltip type='solid' id='global' />
        <div className='search-wrapper'>
          <div className='main-content'>
            <FiltersGroup
              triggerApi={this.triggerApi}
              resortDetails={this.props.resortDetails}
              monthes={monthes}
              isWidget={this.props.isWidget}
              selectedFilters={this.state.selectedFilters}
              items={this.props.filters}
              title={this.props.title}
              updateParams={this.updateParams}
              clearDates={this.clearDates}
              clearSelectedFilters={this.clearSelectedFilters}
              trustpilotLocale={this.props.trustpilotLocale}
              filtersCount={this.state.filtersCount}
              model={this.props.model}
              groupTrips
              pk={this.props.pk}
            />
            <div className='result-list'>
              <div className='results-head'>
                <h1>
                  <FormattedMessage
                    id='search.title.group_trip'
                    values={{
                      qty: this.state.numberOfBoats,
                      location: this.props.inTitle,
                    }}
                    defaultMessage='{ qty, plural, one {# group trip} other {# group trips }} { location }' />
                </h1>
                <div className='results-actions'>
                  <MobileFilterToggle filtersCount={this.state.filtersCount} />
                </div>
              </div>
              {
                <TripItem
                  setNumberOfItems={this.setNumberOfItems}
                  selectedParams={this.state.selectedParams}
                  getNewData={this.state.getNewData}
                  {...this.props} />
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default connect(
  state => ({
    numberOfTrips: state.numberOfTrips,
  })
)(SearchPageGroup)
